import {Grid} from '@logistics-frontend/blocks'
import {FormControlLabel} from '@logistics-frontend/blocks/lpc/form-control-label'
import {GridHeader} from '@logistics-frontend/blocks/lpc/grid-header'
import {Radio, RadioGroup} from '@logistics-frontend/blocks/lpc/radio'
import {useRequirementValue} from '@yandex-taxi/react-integration-api'
import React, {useCallback} from 'react'

import {useRequirementGoalCallback} from '../../../../shared/metrika'
import {useRequirementOptionsWithDefault} from './hooks'
import {Props} from './types'

const SelectRequirement: React.FC<Props> = ({requirement, tariff}) => {
  const type = requirement.select?.type
  const defaultValue = requirement.default
  const [{value = defaultValue, touched, error}, {setValue}] = useRequirementValue<string | number>(requirement.name)
  const options = useRequirementOptionsWithDefault(requirement)
  const goalCallback = useRequirementGoalCallback(tariff, requirement.name)
  const changeHandler = useCallback(
    (_, stringValue: string) => {
      const value = type === 'number' ? parseInt(stringValue, 10) : stringValue
      const nextValue = value === defaultValue ? undefined : value

      setValue(nextValue)
      goalCallback(nextValue)
    },
    [defaultValue, goalCallback, setValue, type],
  )

  if (!options) {
    return null
  }

  return (
    <Grid spacing={1} container>
      <GridHeader xs={12} item>
        {requirement.label}
      </GridHeader>
      <Grid xs={12} item>
        <RadioGroup onChange={changeHandler} value={`${value}`}>
          {options.map(option => (
            <FormControlLabel
              key={option.name}
              control={<Radio color="primary" error={!!(touched && error)} />}
              label={option.title}
              value={`${option.value}`}
            />
          ))}
        </RadioGroup>
      </Grid>
    </Grid>
  )
}

export default SelectRequirement
